import { makeStyles } from '@fluentui/react-components';

export const useAssetPreviewStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    height: '42px',
    marginTop: '5px',
    marginBottom: '5px',
  },
  imagePreviewContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '& .cropped-image-view': {
      boxShadow: '0px 1.600000023841858px 3.5999999046325684px 0px #00000021',
      borderTopLeftRadius: '3px',
      borderTopRightRadius: '3px',
      borderBottomLeftRadius: '3px',
      borderBottomRightRadius: '3px',
      height: 'auto !important',
      maxHeight: '48px',
      backgroundColor: 'white',
      '& img': {
        height: '100%',
        width: '100% !important',
        objectFit: 'contain',
      },
    },
  },
  aspectRatio: {
    marginLeft: '8px',
  },
  text: {
    display: '-webkit-box',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
    overflowY: 'hidden',
  },
});

